import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppFilter } from '@app/shared/models/filter';

@Component({
  selector: 'app-document-upload-row',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
})
export class DocumentUploadRowComponent implements OnInit {
  @Input() application: any;
  @Input() organizationAol: any;
  @Input() disabled: boolean;
  @Output() onView = new EventEmitter();
  @Output() edit = new EventEmitter();
  @Output() deleteAssessment = new EventEmitter();
  pending: boolean = false;
  requests;
  datas;
  // datas = [
  //   { name: "Crab Lorem Ipsum", status: "APPROVED" },
  //   {
  //     name: "Fish Lorem Ipsum",
  //     status: "iN PROGRESS",
  //     text: "Approved, awaiting payment",
  //   },
  //   {
  //     name: "Fish Lorem Ipsum",
  //     status: "DECLINED",
  //     text: "License available",
  //   },
  //   { name: "Fish Lorem Ipsum", status: "APPROVED" },
  // ];
  serviceType;
  error;
  collapseInvoice = true;

  unreadComments: number = 0;
  unread;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  removeUnderScore(e) {
    if (e != null) {
      return e.replaceAll('_', ' ');
    }
    return '-';
  }

  toggleCollapse() {
    this.collapseInvoice = !this.collapseInvoice;
    this.pending = true;
    // this.applicationService
    //   .getServiceRequest({ applicationId: this.application.applicationId })
    //   .subscribe((res) => {
    //     this.datas = res;
    //     console.log('this.requests', this.datas);
    //     this.pending = false;
    //   });
  }

  returnProductName(item) {
    if (
      item.serviceTypeId === 'REQUEST_FOR_PRODUCT_CERTIFICATION' ||
      item.serviceTypeId === 'Export-Permit' ||
      item.serviceTypeId === 'Import-Permit'
    ) {
      let facilityData = JSON.parse(item.facilityData);
      return facilityData.productName;
    } else {
      let serviceRequest = JSON.parse(item.serviceRequestFields);
      return serviceRequest.name;
    }
  }
}
